<template>
  <sui-segment attached="bottom">
    <sui-table size="large" celled>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell>Account</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-show="accounts.length">
        <sui-table-row :class="{positive: account.id === acc.id}" v-for="acc in accounts" :key="acc.id">
          <sui-table-cell class="account-cell" :width="8">
            <div class="entity">
              <Logo class="entity-logo" :src="acc.avatar" :email="acc.email" square />
              <div class="entity-info">
                <b>{{acc.name}}</b><span v-show="user.defaultAcc === acc.id"> (default)</span><br>
                <small>{{acc.email}}</small>
              </div>
              <small class="entity-limits" :class="{expired: acc.expiration && !acc.subscription.active}">
                <b>{{tariffsById[acc.tariff].name}}</b>
                <span v-if="acc.expiration">
                  <br><time>until {{momentFormat(acc.expiration, 'LL')}}</time>
                </span>
              </small>
              <sui-button class="entity-button" size="tiny" icon="cog" color="blue" data-goal="ACCOUNT_ACCOUNTS_EDIT" basic @click.prevent="$modals.updateAccount.open(acc)" />
              <sui-button class="entity-button" color="green" size="tiny" icon="sign in" :disabled="account.id === acc.id || isMembershipOver(acc.member && acc.member.expiration)" data-goal="ACCOUNT_ACCOUNTS_LOGIN" style="margin: 0" @click.prevent="acc.use()">Enter</sui-button>
            </div>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer>
        <sui-table-row>
          <sui-table-header-cell>
            <sui-button color="green" size="small" icon="plus" label-position="left" data-goal="ACCOUNT_ACCOUNTS_ADD" @click.prevent="$modals.createAccount.open()">Create account</sui-button>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
    <sui-message error v-if="apiErrors">
      {{apiErrors}}
    </sui-message>
  </sui-segment>
</template>

<script>
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  import objects from '@/objects'

  export default {
    name: 'AccountAccountsView',
    data() {
      return {
        apiErrors: null,
        demoLimit: objects.Host.fields.amt.creatingDemo.max,
      }
    },
    computed: {
      ...mapGetters(['account', 'accounts', 'hosts', 'member', 'members', 'tariffsById', 'user']),
      ownHosts() {
        return this.hosts.filter(host => !host.demo)
      },
    },
    methods: {
      isMembershipOver(date) {
        return date ? moment(Date.now()).diff(new Date(date).getTime()) > 0 : false
      },
    },
  }
</script>

<style scoped>
  small { font-size: .8em; color: #999; }
  .entity { display: flex; align-items: center; }
  .entity-button { margin: 0 0 0 .5em!important; }
  .entity-icon { font-size: 1.8em; vertical-align: middle; margin-right: .5em; }
  .entity-info { flex: 1; }
  .entity-limits { float: right; text-align: right; line-height: 1.2; }
  .entity-logo { margin-right: .5em; height: 2em!important; width: 2em!important; border-radius: .2em; }
  .expired { color: #c66; }
</style>
